import styled from 'styled-components/macro';

import mq from '../../../../utils/mediaQueriesBp';

import H3 from '../../../../atoms/H3';
import P from '../../../../atoms/P';

import { NavLink } from 'react-router-dom';
import H2 from 'atoms/H2';

interface IProps {
  isPreview: boolean;
}

const Wrapper = styled.div<IProps>`
  display: flex;
  flex: 0 1 100%;
  flex-direction: column;
  transition: all 0.5s ease-in-out;

  &:hover {
    box-shadow: 0px 4px 10px 2px rgba(0, 0, 0, 0.13);
  }

  ${mq('laptop')} {
    flex: 0 1 48%;
  }

  ${mq('desktop')} {
    flex: 0 1 32%;
  }

  ${props =>
    !props.isPreview
      ? `
        margin-bottom: 60px;
      `
      : `
        margin-bottom: 30px;
        
        :last-child {
          display: none;
        }
        
        ${mq('desktop')} {
          flex: 0 1 32%;
          
          :last-child {
            display: flex;
          }
        }
      `}
`;

const Header = styled.div`
  display: flex;
  height: min-content;
  min-height: 70px;
  align-items: center;
  justify-content: space-between;
  padding: 5px 20px;
  background: ${props => props.theme.colors.cyan};
`;

const Inner = styled.div`
  display: flex;
  flex: 1;
  min-height: 200px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow-y: auto;
  padding: 30px 20px;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const TriggerContainer = styled.div`
  width: 200px;
`;

const Title = styled(H2)`
  font-size: 20px;
  line-height: 26px;
  font-weight: 700;
  color: ${p => p.theme.colors.black};
  margin: 0;

  ${mq('laptop')} {
    font-size: ${(24 / 1024) * 100}vw;
    line-height: ${(30 / 1024) * 100}vw;
  }

  ${mq('desktop')} {
    font-size: ${(24 / 1440) * 100}vw;
    line-height: ${(30 / 1440) * 100}vw;
  }

  ${mq('large')} {
    font-size: 24px;
    line-height: 30px;
  }
  color: white;
`;

const Description = styled(P)`
  overflow: hidden;
  margin-bottom: 30px;
`;

const Link = styled(NavLink)`
  text-decoration: none;
`;

export { Wrapper, Header, Inner, Title, Description, TriggerContainer, Link };
